import Link from 'next/link';
import React, { memo } from 'react';

import { capitalizeFLetter } from '@/utils/helpers';
function DetailBreadcrumb({ adsDetail }: { adsDetail: any }) {
  return (
    <section className="breadcrum-sec" style={{ marginTop: '70px' }}>
      <div className="container">
        <nav className="breadcrumb-row">
          <ol className="breadcrumb mybrcrumb">
            <li className="breadcrumb-item homeIcon">
              <Link href="/">
                <i className="fa fa-home">
                  <span className="bcseo-text">247Torax India</span>
                </i>
              </Link>
            </li>
            <li className="breadcrumb-item">
              <Link href={`/${adsDetail.category}`}>
                <div> Indian Call Girls</div>
              </Link>
            </li>
            <li className="breadcrumb-item">
              <Link
                href={`/${adsDetail.category}/${
                  adsDetail.city === 'chennai' || adsDetail.city === 'hyderabad'
                    ? capitalizeFLetter(adsDetail.city)
                    : adsDetail.city
                }`}
              >
                <div>{'Call Girls In ' + capitalizeFLetter(adsDetail.city)}</div>
              </Link>
            </li>
            <li className="breadcrumb-item">
              <div>{adsDetail.adsNo}</div>
            </li>
          </ol>
        </nav>
      </div>
    </section>
  );
}

export default memo(DetailBreadcrumb);
